import { EditorView } from '@tiptap/pm/view'

const editorViewRegistry = new WeakMap<HTMLElement, EditorView>()

export function registerEditorView(view: EditorView): void {
  editorViewRegistry.set(view.dom, view)
}

export function unregisterEditorView(view: EditorView): void {
  // A newer view mounted on the same DOM node keeps its entry
  if (editorViewRegistry.get(view.dom) === view) editorViewRegistry.delete(view.dom)
}

export function getEditorViewFromDom(dom: HTMLElement | null): EditorView | null {
  if (!dom) return null
  return editorViewRegistry.get(dom) || null
}
